import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../../store/use-thunk-dispatch';
import { SpecialOfferProduct } from '../models/special-offer-product';

export const SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_FETCH = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_FETCH';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_RECEIVED = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_RECEIVED';

const receiveSupplierSpecialOffersProducts = (products: PaginatedResponse<SpecialOfferProduct>) => {
    return {
        type: SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_RECEIVED,
        products,
    };
};

export const fetchSupplierSpecialOffersProducts = (specialOfferId: number, searchParams: URLSearchParams) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_FETCH });

        const response = await api.contentManagement.SupplierSpecialOffers.Detail.Products.getProducts(
            specialOfferId,
            searchParams
        );

        if (response.success) {
            dispatch(receiveSupplierSpecialOffersProducts(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
